import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, finalize } from 'rxjs';

import { LoaderService } from '@services/loader.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private totalRequests: number = 0;

  constructor(private loader: LoaderService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.totalRequests++;
    const loading = request.params.get('loader') === 'false' ? false : true;
    this.loader.setLoading(loading);

    return next.handle(request).pipe(
      finalize(() => {
        if (--this.totalRequests === 0) {
          this.loader.setLoading(false);
        }
      })
    );
  }
}
